/**
 * General Date Constants
 */
export const DateConstants = Object.freeze({
    MONTHS: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
})